import { getRequest, postRequest, patchRequest } from "../../config/axiosConfig";

export const getAllPatient = async ({ limit, page }) => {
  try {
    const response = await getRequest({
      url:
        process.env.REACT_APP_BASE_URL + `management/get-all-patient?limit=${limit}&page=${page}`,
    });

    if (response?.data) {
      return {
        success: true,
        data: response,
        message: "Patient fetched Successfull!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid fetched attempt for patient.",
    };
  }
};
export const getPatientById = async ({ id }) => {
  try {
    const response = await postRequest({
      url:
        process.env.REACT_APP_BASE_URL + "management/get-patient-by-id",
        data: {id}
    });

    if (response?.data) {
      return {
        success: true,
        data: response,
        message: "Patient fetched Successfull!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid fetched attempt for patient.",
    };
  }
};

export const changePatientStatus = async ({ id, isActive }) => {
  try {
    const response = await patchRequest({
      url: process.env.REACT_APP_BASE_URL + "management/toggle-patient-status",
      data: {
        patient_id: id,
        is_active: isActive
      },
    });

    if (response?.status === 200) {
      return {
        success: response?.status === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid change patient status.",
    };
  }
};